import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class RequestContextService {
  requestHeaders?: Record<string, string>;
  responseHeaders?: Record<string, string>;

  clear() {
    this.requestHeaders = undefined;
    this.responseHeaders = undefined;
  }
}
